<div
  class="lists-container d-flex fd-row ai-stretch gap-8"
>
  <ng-container *ngFor="let toggleGroup of toggleGroups">
    <div
      class="list-container flex-1 d-flex fd-col ai-stretch"
    >
      <p class="parent-checkbox">
        <mat-checkbox
          [checked]="toggleGroup.checked"
          [indeterminate]="toggleGroup.indeterminate"
          (change)="parentCheckedChanged(toggleGroup, $event)"
          color="primary"
          >{{ toggleGroup.name }}</mat-checkbox
        >
      </p>
      <p
        class="child-checkbox"
        *ngFor="let child of toggleGroup.children; let i = index"
      >
        <mat-checkbox
          [formControl]="toggleGroup.getControl(child.name)"
          (change)="childCheckedChanged()"
          color="primary"
          >{{ child.name }}
        </mat-checkbox>
      </p>
    </div>
  </ng-container>
</div>
